import { SportBetType } from '../data-types/betting/bettingEnums';
import { SystemBetConfigResponse } from '../data-types/betting/bettingInterfaces';
import { DEFAULT_ERROR_MESSAGE } from '../data-types/initialisation/initialisationConstants';
import { Ticket } from '../data-types/sports/sportsInterfaces';
import { ticketSystemBetSettings } from '../socket-types/ticketSocketTypes';
import { setSystemBetConfig } from '../state/actions/betActions';
import { isEventLiveOrUpcoming } from '../utils/event';
import { enqueueSnackbarPrompt } from '../utils/prompts';
import { sortByTimePlaced } from '../utils/ticket';
import { sendCommand } from './commandsHandler';
import { getSportsTickets, retrieveEvents } from './sportsCommands';

export const getSportBetTickets = async (tab: SportBetType, page: number) => {
  try {
    return (await getSportsTickets(tab === SportBetType.ACTIVE, page)) || [];
  } catch (error) {
    enqueueSnackbarPrompt(error.message, { closeOnClick: true });
    return [];
  }
};

export const sort = (tickets: Ticket[]): Ticket[] => (tickets ? sortByTimePlaced(tickets) : tickets);

export const retrieveEventsByTickets = (tickets: Ticket[]) => {
  retrieveEvents(
    // convert the resulting object to array
    Object.values(
      tickets
        .flatMap(({ bets }) => bets) // retrieve the bets from the tickets
        .map(({ event, sportId }) => ({ event, sportId })) // get only the data that's relevant to us
        .filter(({ event }) => isEventLiveOrUpcoming(event)) // filter by status
        .map(({ event: { id }, sportId }) => ({ id, sportId })) // transform it to the structure of the API
        .reduce((accumulator, entry) => ({ [entry.id]: entry, ...accumulator }), {}), // dedupe by transforming to an object, keys being the event ID
    ),
  );
};

export const getTicketSystemConfig = async () => {
  const res = await sendCommand<SystemBetConfigResponse>(ticketSystemBetSettings, {});

  if (res.error) {
    throw new Error(res.error.notification.userFriendlyMessage);
  }

  if (res.data) {
    return res.data;
  }

  throw new Error(DEFAULT_ERROR_MESSAGE);
};

export const getTicketSystemConfigSilently = async () => {
  try {
    const res = await getTicketSystemConfig();
    setSystemBetConfig(res);
  } catch (e) {
    // do nothing
  }
};
